import type { SVGAttributes } from 'react';

export function PlayMediaIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg aria-hidden={true} fill="currentColor" focusable={false} viewBox="0 0 16 16" {...props}>
      <path d="M12.281 7.202c.313.182.469.45.469.8 0 .352-.156.619-.469.8l-6.875 4.061c-.3.183-.612.183-.937 0-.313-.169-.469-.436-.469-.8v-8.12c0-.391.163-.665.488-.82.339-.17.645-.163.918.019l6.875 4.06z" />
    </svg>
  );
}
